"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
exports.TaskSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.Xlsx2Csv2TransformationConvertRangeSchema.omit({
        srcDataTape: true,
    }).extend({
        srcArtifactSlug: zod_1.z.string(),
    }),
    tape_sanitizer_1.Xlsx2Csv2TransformationExtractValuesSchema.omit({
        srcDataTape: true,
    }).extend({
        srcArtifactSlug: zod_1.z.string(),
    }),
]);
exports.UiConfigSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.Xlsx2Csv2TransformationConvertRangeSchema.omit({
        srcDataTape: true,
    }),
    tape_sanitizer_1.Xlsx2Csv2TransformationExtractValuesSchema.omit({
        srcDataTape: true,
    }),
]);
exports.nodeType = 'operation_xlsx2csv2';
//# sourceMappingURL=types.js.map